import { useState, useEffect } from 'react'
import { Card, Table, Button, Modal, Descriptions, Row, Col, message } from 'antd'
import { FileTextOutlined, EyeOutlined } from '@ant-design/icons'
import { financeApi } from '../../services/api'

export default function Vouchers() {
  const [vouchers, setVouchers] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const [detailVisible, setDetailVisible] = useState(false)
  const [currentVoucher, setCurrentVoucher] = useState<any>(null)
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 })

  useEffect(() => { loadVouchers() }, [])

  const loadVouchers = async (page = 1) => {
    setLoading(true)
    try {
      const res = await financeApi.getVouchers({ page, page_size: pagination.pageSize })
      // axios interceptor already unwraps response.data
      const vdata = res.data || res
      setVouchers(Array.isArray(vdata) ? vdata : [])
      setPagination(prev => ({ ...prev, current: page, total: (res as any).total || 0 }))
    } catch (e) { console.error(e) }
    setLoading(false)
  }

  const viewDetail = async (id: number) => {
    try {
      const res = await financeApi.getVoucher(id)
      setCurrentVoucher(res.data || res)
      setDetailVisible(true)
    } catch (e: any) {
      message.error('获取凭证详情失败')
    }
  }

  const sourceTypeMap: Record<number, string> = { 1: '手工录入', 2: '订单收入', 3: '采购付款', 4: '储值充值' }

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: '凭证号', dataIndex: 'voucher_number', width: 140 },
    { title: '日期', dataIndex: 'voucher_date', width: 110 },
    { title: '摘要', dataIndex: 'description', ellipsis: true },
    { title: '借方金额', dataIndex: 'total_debit', width: 120, render: (v: number) => <span style={{ fontWeight: 600 }}>¥{Number(v || 0).toFixed(2)}</span> },
    { title: '贷方金额', dataIndex: 'total_credit', width: 120, render: (v: number) => <span style={{ fontWeight: 600 }}>¥{Number(v || 0).toFixed(2)}</span> },
    { title: '来源', dataIndex: 'source_type', width: 90, render: (v: number) => sourceTypeMap[v] || '其他' },
    { title: '会计期间', dataIndex: 'accounting_period', width: 100 },
    {
      title: '操作', width: 80,
      render: (_: any, record: any) => (
        <Button size="small" icon={<EyeOutlined />} onClick={() => viewDetail(record.id)}>详情</Button>
      )
    }
  ]

  return (
    <div>
      <Card title={<span><FileTextOutlined /> 凭证管理</span>}>
        <Table columns={columns} dataSource={vouchers} rowKey="id" loading={loading}
          pagination={{ ...pagination, onChange: (page) => loadVouchers(page) }} size="middle" />
      </Card>

      <Modal title={`凭证详情 - ${currentVoucher?.voucher_number || ''}`} open={detailVisible} onCancel={() => setDetailVisible(false)} width={700} footer={null}>
        {currentVoucher && (
          <div>
            <Descriptions size="small" column={2} bordered style={{ marginBottom: 16 }}>
              <Descriptions.Item label="凭证号">{currentVoucher.voucher_number}</Descriptions.Item>
              <Descriptions.Item label="日期">{currentVoucher.voucher_date}</Descriptions.Item>
              <Descriptions.Item label="来源">{sourceTypeMap[currentVoucher.source_type] || '其他'}</Descriptions.Item>
              <Descriptions.Item label="会计期间">{currentVoucher.accounting_period}</Descriptions.Item>
              <Descriptions.Item label="摘要" span={2}>{currentVoucher.description}</Descriptions.Item>
              <Descriptions.Item label="借方合计">¥{Number(currentVoucher.total_debit || 0).toFixed(2)}</Descriptions.Item>
              <Descriptions.Item label="贷方合计">¥{Number(currentVoucher.total_credit || 0).toFixed(2)}</Descriptions.Item>
            </Descriptions>
            {currentVoucher.entries && currentVoucher.entries.length > 0 && (
              <Table
                size="small"
                pagination={false}
                dataSource={currentVoucher.entries}
                rowKey="id"
                columns={[
                  { title: '科目', dataIndex: 'account_name', width: 150 },
                  { title: '摘要', dataIndex: 'summary', ellipsis: true },
                  { title: '借方金额', dataIndex: 'debit_amount', width: 120, render: (v: number) => v ? `¥${Number(v).toFixed(2)}` : '' },
                  { title: '贷方金额', dataIndex: 'credit_amount', width: 120, render: (v: number) => v ? `¥${Number(v).toFixed(2)}` : '' }
                ]}
              />
            )}
          </div>
        )}
      </Modal>
    </div>
  )
}
